import React, { Component } from "react";

import WeatherTool from "./WeatherTool.js";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authReady: false,
      authFailed: false
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <WeatherTool />
    );
  }
}